/**
 * GDPR Dashboard Service Layer
 * Rule: Business logic, validation, and API orchestration
 * Rule: NO UI IN SDK
 */
import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class GdprDashboardService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getSummary() {
        try {
            const response = await withRetry(() => this.api.getSummary(), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch GDPR dashboard summary');
        }
    }

    async getRopaReport() {
        try {
            const blob = await this.api.getRopaReport();
            return { success: true, data: blob };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch ROPA report');
        }
    }

    async getAuditPack() {
        try {
            const blob = await this.api.getAuditPack();
            return { success: true, data: blob };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch audit pack');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
